import config from 'config';
import {
  FinalizeAdyenResponse,
  PrepareAdyenResp,
  UseAdyenCCPayPayload,
  UseAdyenCCPayResp,
} from 'types/transaction-adyen';
import fetchWithToken from './provider/fetch';

const transactionAdyenEndPoint = (accountKey: string, sessionId: string, paymentMethod: string): string =>
  `${config.COPAS_URL}/payment/ui/cip/v1/${accountKey}/session/${sessionId}/transaction/${paymentMethod}`;

// Prepare Adyen transaction
export const daoTransactionAdyenPreparePost = (
  accountKey: string,
  sessionId: string,
  data: object,
  paymentMethod: string,
): Promise<PrepareAdyenResp> =>
  fetchWithToken({
    reqUrl: `${transactionAdyenEndPoint(accountKey, sessionId, paymentMethod)}/prepare`,
    method: 'POST',
    body: JSON.stringify(data),
  });

// Finalize Adyen transaction
export const daoTransactionAdyenFinalizePost = (
  accountKey: string,
  sessionId: string,
  data: object,
  paymentMethod: string,
): Promise<FinalizeAdyenResponse> =>
  fetchWithToken({
    reqUrl: `${transactionAdyenEndPoint(accountKey, sessionId, paymentMethod)}/finalize`,
    method: 'POST',
    body: JSON.stringify(data),
  });

// Use Adyen's stored credit card to pay
export const daoTransactionAdyenUseCcPayPost = (
  accountKey: string,
  sessionId: string,
  data: UseAdyenCCPayPayload,
): Promise<UseAdyenCCPayResp> =>
  fetchWithToken({
    reqUrl: `${transactionAdyenEndPoint(accountKey, sessionId, 'cca')}/stored/pay`,
    method: 'POST',
    body: JSON.stringify(data),
  });

export const daoTransactionAdyenUseCcPaySCAPost = (
  accountKey: string,
  sessionId: string,
  data: object,
): Promise<UseAdyenCCPayResp> =>
  fetchWithToken({
    reqUrl: `${transactionAdyenEndPoint(accountKey, sessionId, 'cca')}/stored/pay/verify`,
    method: 'POST',
    body: JSON.stringify(data),
  });
